<template lang="pug">
  div
    slot(name='svg-icons')
    app-main-menu
    main(
      role="main"
      :class="{ 'pl-main-menu-width': !isMainMenuCollapsed }"
      v-loading="loading"
    ).main-content.pos-r
      // global header
      app-header

      //- views render here
      transition(name='fade')
        router-view
</template>

<script>
import { mapGetters } from 'vuex';

import AppMainMenu from '@/components/AppMainMenu.vue';
import AppHeader from '@/components/AppHeader.vue';

export default {
  name: 'DashView',
  components: { AppMainMenu, AppHeader },
  computed: {
    ...mapGetters('shared', ['loading', 'isMainMenuCollapsed']),
  },
};
</script>
